import {create} from 'zustand';
import {taskTypeApi} from '../services/api/taskTypeApi';

export const useTaskTypeStore = create((set, get) => ({
  taskTypes: [],
  isLoading: false,

  fetchTaskTypes: async () => {
    set({isLoading: true});
    try {
      const response = await taskTypeApi.list();
      set({taskTypes: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  createTaskType: async (data) => {
    const response = await taskTypeApi.create(data);
    const newItem = response.data.data;
    set(state => ({taskTypes: [...state.taskTypes, newItem]}));
    return newItem;
  },

  updateTaskType: async (id, data) => {
    const response = await taskTypeApi.update(id, data);
    const updated = response.data.data;
    set(state => ({
      taskTypes: state.taskTypes.map(t => (t.id === id ? updated : t)),
    }));
    return updated;
  },

  deleteTaskType: async (id) => {
    await taskTypeApi.remove(id);
    set(state => ({
      taskTypes: state.taskTypes.filter(t => t.id !== id),
    }));
  },

  reorderTaskTypes: async (orderedIds) => {
    // Optimistic reorder
    set(state => {
      const map = {};
      state.taskTypes.forEach(t => {
        map[t.id] = t;
      });
      const reordered = orderedIds
        .map((id, idx) => (map[id] ? {...map[id], displayOrder: idx + 1} : null))
        .filter(Boolean);
      return {taskTypes: reordered};
    });
    try {
      await taskTypeApi.reorder(orderedIds);
    } catch (e) {
      // Revert on failure
      await get().fetchTaskTypes();
      throw e;
    }
  },
}));
